const icon = require('vue-svgicon');
icon.register({
    'caret-right-solid': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16c8.823 0 16-7.177 16-16S24.822 0 16 0zm5.393 17.115l-7.283 7.28c-.32.319-.838.319-1.158 0s-.32-.837 0-1.156l6.704-6.703-6.705-6.702c-.32-.318-.32-.836 0-1.155s.838-.319 1.158 0l7.283 7.28a.826.826 0 01.001 1.156z"/>`,
    },
});
